"use strict";

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var date_fns_1 = require("date-fns");

var date_fns_tz_1 = require("date-fns-tz");

var react_1 = __importDefault(require("react"));

exports.DATE_FORMAT = "yyyy-MM-dd-HH-mm";
/**
 * Returns a UTC Date object, defaulting to the current date
 * @param date
 */

function getUTCDate(date) {
  if (date === void 0) {
    date = new Date();
  }

  return date_fns_tz_1.zonedTimeToUtc(date, 'EST');
}
/**
 * Translate from human-friendly format into a Date
 * @param date `yyyy-MM-dd-HH-mm` (hours and minutes optional)
 */


function parseDateString(date) {
  var values = date.split('-').map(Number);

  if (values.length > 1) {
    values[1] -= 1; // JS months are -1
  } // @ts-ignore


  return getUTCDate(new (Date.bind.apply(Date, __spreadArrays([void 0], values)))());
}
/**
 * If there's a `date` property in the querystring, override the local system date
 * @param location
 */


function getDateFromQuerystring(location) {
  var currentDate = getUTCDate();

  try {
    var query = new URLSearchParams(location.search).get('date');

    if (query) {
      // @ts-ignore
      currentDate = parseDateString(query);
    }
  } catch (e) {
    console.error('Date comparison error', e);
  }

  return currentDate;
}

var TimeSensitive = function TimeSensitive(_a) {
  var children = _a.children,
      location = _a.location,
      start = _a.start,
      end = _a.end;
  var now = getDateFromQuerystring(location);
  var interval = {
    start: parseDateString(start),
    end: parseDateString(end)
  };

  if (!date_fns_1.isWithinInterval(now, interval)) {
    return null;
  }

  return react_1["default"].createElement(react_1["default"].Fragment, null, children);
};

TimeSensitive.displayName = "TimeSensitive";
exports["default"] = TimeSensitive;